<template>
  <div id="journal_content">
    <!-- all_in -->
    <div class="con_all">
      <div class="con_box2">
        <p style="border-left: 3px solid #bbb;padding-left: 10px;font-size: 20px;">{{showName(type)}}</p>
        <table width="100%" style="margin-top: 20px;">
          <tr>
            <td>{{showPage.fileName}}</td>
          </tr>
          <tr v-for="(journal,index) in journals" :key="index">
            <td>
              <a :href="journal.fileUrl" download>
                <div>{{journal.title}}</div>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'journal_content',
  props: ['type'],
  data() {
    return {
      journalId: this.$route.params.journalid,
      journals: [],
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initJournals();
      this.initType();
    },
    initJournals() {
      this.getData();
    },
    initType() {
      // this.$emit
    },
    getData() {
      axios.get(API.journal + `?typeId=${this.journalId}`)
        .then(response => {
          this.journals = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.sort();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    sort() {
      this.journals.sort((a, b) => {
        let aDate = new Date(a.createdAt),
          bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime())
          return 1;
        return -1;
      });
    },

    showName(type) {
      if (!type) return ''
      let show = { 'CH': type.nameCh, 'EN': type.nameEn }
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#journal_content {
  a {
    color: #21ABCA;
  }
}

</style>



// WEBPACK FOOTER //
// JournalContent.vue?7b608060